









































































































































import { GroupManagerService as groupApi } from "@/common/api/services/GroupManagerService";
import { MeService as meApi } from "@/common/api/services/MeService";
import { formatImageUrl } from "@/common/utils";
import QErrors from "@/common/qErrors.vue";
import Vue from "vue";
import Component from "vue-class-component";
import qNotify from "@/common/qNotify";
import { namespace } from "vuex-class";

const auth = namespace("MemberAuth");

@Component({
  name: "Template",
  components: {
    QErrors,
  },
})
export default class Template extends Vue {
  @auth.Getter
  getLoggingUser;

  showFollowRequest = false;

  params: any = {
    id: null,
  };
  detail: any = {
    image: null,
    name: null,
    follow: 0,
  };
  errors = {};

  form: any = {
    comment: "",
    groupId: null,
  };

  followMap = {
    "": "",
    0: "wait",
    1: "follow",
  };

  get isShowContent() {
    return (
      this.detail && (this.detail.follow || this.detail.request_approved == 0)
    );
  }

  get followStatus() {
    return this.followMap[this.detail.follow];
  }
  activeMenu(value: [string]) {
    this.setTitle(this.detail.name);
    return value.includes(this.$router.currentRoute.name) ? "select" : "";
  }

  mounted() {
    this.params.id = Number.parseInt(this.$router.currentRoute.params.groupId);
    this.form.groupId = Number.parseInt(
      this.$router.currentRoute.params.groupId
    );

    this.getDetail();
  }

  async getDetail() {
    try {
      const result = await groupApi.memberGroupInfoShow(this.params);

      this.detail = result.data.group;

      this.setTitle(this.detail.name);
    } catch (error) {
      if (error.status === 404) {
        return this.$router.push({
          name: "group.notFound",
          params: { groupId: this.params.id },
        });
      } else {
        qNotify.error({
          text: error.body.message,
        });
      }
    }
  }

  setTitle(groupName) {
    Vue.nextTick(() => {
      document.title = `${groupName} |【WENAVI】会員制対応の情報発信サイト`;
    });
  }

  getImagePath(image, size = "400x400") {
    return image
      ? formatImageUrl(image.name, size)
      : formatImageUrl("not-found.jpg", size);
  }

  follow() {
    if (!this.getLoggingUser) {
      this.$router.push({ name: "login" });
      return;
    }
    if (this.detail.request_approved && this.detail.follow === null) {
      this.form.comment = "";
      this.showFollowRequest = true;
    } else {
      this.doFollow();
    }
  }

  async doFollow() {
    let result;
    try {
      result = await meApi.meFollow(this.form);
    } catch (error) {
      result = error.body;
    }

    if (result.status === "error") {
      this.$notify({
        text: result.message,
      });
      this.errors = result.errors;
    } else {
      this.getDetail();
      this.showFollowRequest = false;
      this.$router.push({
        name: "group.blog",
        params: { groupId: this.params.id },
      });
    }
  }
}
